export function ticketLastActivityMs(ticket) {
	if (!ticket) return 0;
	const raw = ticket.lastMessageObj?.createdAt || ticket.updatedAt;
	if (!raw) return 0;
	return new Date(raw).getTime();
}

export function sortTicketsByLastActivity(tickets, direction) {
	const desc = direction !== "asc";
	return [...tickets].sort((a, b) => {
		const diff = ticketLastActivityMs(b) - ticketLastActivityMs(a);
		return desc ? diff : -diff;
	});
}
